<a [routerLink]="['/schedule']" routerLinkActive="active">
  <span class="text">{{ 'Расписание' | translate }}</span>
</a>
